import * as turf from "@turf/turf";

export const getAOIMetrics = (feature: any) =>
{
      if (!feature?.geometry) return null;

      const polygon = turf.polygon(feature.geometry.coordinates);

      const area = turf.area(polygon); // m²
      const perimeter = turf.length(turf.polygonToLine(polygon), {
            units: "kilometers",
      }); // km

      return {
            area,
            perimeter,
      };
};


export const WIDGETS = {
      INPUT: "input",
      TEXTAREA: "textarea",
      SELECT: "select",
      DATE: "date",
      NUMBER: "number",
      RANGE_NUMBER: "range_number"
} as const;


export const UNIT_RULES = [
      { match: ["off_nadir", "angle"], unit: "°" },
      { match: ["cloud_cover", "percent"], unit: "%" },
      { match: ["distance"], unit: "m" },
];


export const detectUnit = (key: string) =>
{
      const lowerKey = key.toLowerCase();

      for (const rule of UNIT_RULES)
      {
            if (rule.match.some((k) => lowerKey.includes(k)))
            {
                  return rule.unit;
            }
      }

      return "";
};

export const formatLabelWithUnit = (key: string, t: any) =>
{
      // format label
      const baseLabel = key
            .replace(/[_:]/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());

      const unit = detectUnit(key);

      return unit ? `${t(baseLabel)} (${unit})` : t(baseLabel);
};

export const dataKeyGeneral = [
      "geometry",
      "description_order",
      "order_name",
      "priority",
      "reason",
      "order_type",
];
